import { Faces } from "./faces";
import { DenteArea } from "./dente-area";
import { Procedimentos } from "./procedimentos";
import { DentistaRadiologia } from "./dentista-radiologia";

export class FiltroNovaGto {
    constructor(
        public procedimento?: Procedimentos,
        public dente?: DenteArea,
        public faces?: Array<Faces>,
        public radiologia?: DentistaRadiologia
        ){
        this.radiologia = new DentistaRadiologia();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/base/vo/filtro-nova-gto.ts